// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  padding: 0.75rem 1rem;
  border-radius: 4px;
  :hover {
    cursor: pointer;
  };

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };
`;

export const Status = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const IconContainer = styled.div`
  /* *************** BACKGROUND COLOR *************** */
  background-color: ${({ theme }) => theme.color.moduleHeader.buttonBackgroundColor};
  padding: 2px 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: none;
  height: 20px;
  width: 22px;

  > svg {
    width: 16px;
    height: 16px;
    /* *************** ICON COLOR *************** */
    color: ${({ theme }) => theme.color.moduleHeader.iconColor};
    fill: ${({ theme }) => theme.color.moduleHeader.iconColor};
  };
`;

export const LastOpenedOnTime = styled.span`
  font-family: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.color.crusherDashboard.detailsModule.lastUpdateTimeTextColor};
`;

export const StatusContent = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
`;
